/**
 * HitlCard — DS Pattern
 * Job HITL en attente — approve/reject
 */

import { GlassCard } from '../../organisms';
import { Badge, Button } from '../../atoms';
import styles from './HitlCard.module.css';

interface HitlCardProps {
  jobId: string;
  agentName: string;
  acteType: string;
  timestamp: string;
  onApprove: () => void;
  onReject: () => void;
  loading?: boolean;
  className?: string;
}

export function HitlCard({ jobId, agentName, acteType, timestamp, onApprove, onReject, loading = false, className = '' }: HitlCardProps) {
  return (
    <GlassCard strong className={`${styles.card} ${className}`}>
      <div className={styles.header}>
        <Badge variant="warning">HITL requis</Badge>
        <span className={styles.time}><i className="bi bi-clock me-1" />{timestamp}</span>
      </div>
      <div className={styles.body}>
        <div className={styles.agent}><i className="bi bi-robot me-1" />{agentName}</div>
        <div className={styles.acte}>{acteType}</div>
        <div className={styles.jobId}>Job #{jobId}</div>
      </div>
      <div className={styles.actions}>
        <Button variant="danger" size="sm" onClick={onReject} loading={loading}>
          <i className="bi bi-x-circle me-1" />Rejeter
        </Button>
        <Button variant="success" size="sm" onClick={onApprove} loading={loading}>
          <i className="bi bi-check-circle me-1" />Approuver
        </Button>
      </div>
    </GlassCard>
  );
}
